<template>
  <div class="box-main" v-show="show">
    <transition name="opacity">
      <div class="cover" v-show="show"></div>
    </transition>
    <transition name="alert">
      <div class="box" v-show="show">
        <div class="title"><span>请选择行业领域</span><i class="close iconfont iconx" @click="$emit('close');"></i></div>
        <!-- <div class="option">
          <div
            v-for="(item, index) in optionText"
            :key="index"
            :class="['option-item', index === option ? 'active' : '']"
            @click="selectOption(index, item)">{{item}}</div>
        </div> -->
        <div class="content city-box-content-scroll">
          <div class="city-menu" >
            <!-- <div class="city-menu-before">{{item.group_name === '热门城市' ? '' : item.group_name}}</div> -->
            <div class="city-menu-content">
              <div
                @click="$emit('select', item);"
                class="city-menu-item"
                :class="[
                  (
                    (!queryData.company_industry && item.name === '不限')
                    || queryData.company_industry === item.name
                  )
                  ? 'active' : ''
                ]"
                v-for="(item, index) in conditions.industries"
                :key="index">{{item.name}}</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import api from '@/api';
import conditions from '@/assets/json/conditions';
export default {
  name: 'City',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    queryData: {}
  },
  data() {
    return {
      conditions,
    };
  },
  mounted() {
  },
  methods: {
  },
}
</script>
<style lang="scss" scoped>
.box-main {
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
  .cover {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, .5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 11;
  }
  .box {
    width: 600px;
    height: 400px;
    background: #fff;
    border-radius: 4px;
    position: fixed;
    left: 0;
    bottom: 0;
    top: 0;
    right: 0;
    margin: auto;
    z-index: 12;
    .title {
      padding: 0 24px;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        font-size: 16px;
        color: #404040;
      }
      .iconfont {
        font-size: 18px;
        color: #BCBCBC;
        font-weight: 600;
        cursor: pointer;
      }
    }
    .option {
      width: 100%;
      height: 34px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: rgba(65, 131, 255, .04);
      padding: 0 24px;
      .option-item {
        height: 100%;
        line-height: 34px;
        cursor: pointer;
        font-size: 14px;
        color: #606060;
        position: relative;
        &.active {
          color: #4183FF;
          &::after {
            content: "";
            display: block;
            width: 32px;
            height: 2px;
            background: #4183FF;
            position: absolute;
            left: 50%;
            bottom: 0;
            margin-left: -16px;
          }
        }
      }
    }
    .content {
      height: 306px;
      overflow-y: auto;
    }
    .city-menu {
      display: flex;
      &:first-child {
        margin-top: 24px;
      }
      .city-menu-before {
        width: 64px;
        text-align: center;
        font-size: 14px;
        color: #4183FF;
        flex: none;
      }
      .city-menu-content {
        display: flex;
        flex-wrap: wrap;
        padding: 0 28px;
        .city-menu-item {
          display: block;
          cursor: pointer;
          width: 130px;
          font-size: 14px;
          color: #404040;
          margin-bottom: 30px;
          &.active,
          &:hover {
            color: #4183FF;
          }
        }
      }
    }
  }
}
</style>